import React from "react";
import AddRouteForm from "../route/AddRouteForm";

const CreateOneOffRoute = (props) => {
  return <AddRouteForm {...props} periodEnabled={false} />;
};

export default CreateOneOffRoute;
